/* MINICART FUNCTIONS */
//reinit minicart
function refreshMiniCart(lineitem, quantity) {
    if ($('body').hasClass('template-cart')) {
        window.location.reload();
    } else {
        $.ajax({
            method: "GET",
            url: "/cart",
            data: { "view": "ajax" },
            xhrFields: {
                withCredentials: true
            },
            dataType: 'html',
            success: function(response) {
                var headerCartHtml = $(response).find('.header-cart .action-cart').first().html();
                var toolbarCartHtml = $(response).find('.header-cart-item .action-cart').html();
                var contentCartHtml = $(response).find('.header-cart .minicart-content').first().html();
                
                var subtotal = $(response).find('.header-cart .minicart-content .subtotal .subtotal-price').first().html();
                if ($(response).find('.header-cart.empty').length) {
                    $('.header-cart').addClass('empty');
                } else {
                    $('.header-cart').removeClass('empty');
                }
                if (headerCartHtml) {
                    $('.header-cart .action-cart').html(headerCartHtml);
                }
                if (toolbarCartHtml) {
                    $('.header-cart-item .action-cart').html(toolbarCartHtml);
                }
                if (contentCartHtml) {
                    $('.header-cart .minicart-content').html(contentCartHtml);
                }
                if (subtotal) {
                    $('.header-cart .minicart-content .subtotal .subtotal-price').html(subtotal);
                  
                }
                if (lineitem) {
                    if (quantity) {
                        showSuccessAddToCartPopup(lineitem, quantity, subtotal);
                    } else {
                        showSuccessAddToCartPopup(lineitem, 1, subtotal);
                    }
                }
            }
        });
    }
}
// show hide update-quantity button
document.addEventListener("DOMContentLoaded", function(e) {
    $(document).on('click', '.cart-slideout-inner .edit-qty', function(e) {
        e.preventDefault();
        if ($(this).hasClass('minus')) {
          var qty = parseInt($(this).next().val());
          if (qty > 1) {
            qty = qty - 1;
            $(this).next().val(qty);
          } else {
            $(this).next().val(1);
          }
        } else {
          var qty = parseInt($(this).prev().val());

          if (qty) {
            $(this).prev().val(qty + 1);
          } else {
            $(this).prev().val(1);
          }
        }
        refreshMiniCart();
    });
    // toggle slideout cart
    $(document).on('keyup change', '.minicart-content .details-qty input', function() {
        var currentQty = $(this).val();
        if (currentQty && currentQty != $(this).data('item-qty')) {
            $(this).next().show();
        } else {
            $(this).next().hide();
        }
    });

    // ajax update quantity in minicart
    //click - +
    $(document).on('click', '.minicart-content .edit-qty', function(e) {
        var id = $(this).data('cart-item');
        var oldQuantity = $('.minicart-content .details-qty input[data-cart-item="' + id + '"]').data('item-qty');
        var quantity = $('.minicart-content .details-qty input[data-cart-item="' + id + '"]').val();
        if (quantity && id) {
            if (parseInt(quantity) == 1 && parseInt(oldQuantity) == 1) {
                quantity = 0
            }
                $('.header-cart .minicart-content .ajax-loader').show();
                $.ajax({
                    method: "POST",
                    url: "/cart/update.js",
                    data: "updates[" + id + "]=" + quantity,
                    dataType: "json",
                    success: function(response) {
                        refreshMiniCart();
                        $('.header-cart .minicart-content .ajax-loader').hide();
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        $('.header-cart .minicart-content .ajax-loader').hide();
                        
                    }
                });
            
        }
    });


    $(document).on('change', '.cart-slideout-inner .qty-input', function(e) {
      if ($(this).val() <= 0 || $(this).val() == '') {
        $(this).val(1);
      }
    });

    //change value number
    $(document).on('change', '.item-qty.update-cart-item', function() { 
        var id = $(this).data('cart-item');
        var quantity = $('.minicart-content .details-qty input[data-cart-item="' + id + '"]').val();
        var oldQuantity = $('.minicart-content .details-qty input[data-cart-item="' + id + '"]').data('item-qty');
        if (quantity && id) {
            $('.header-cart .minicart-content .ajax-loader').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: "updates[" + id + "]=" + quantity,
                dataType: "json",
                success: function(response) {
                    refreshMiniCart();
                    $('.header-cart .minicart-content .ajax-loader').hide();
                },
                error: function(XMLHttpRequest, textStatus) {
                    $('.header-cart .minicart-content .ajax-loader').hide();
                    
                }
            });
        }
    });
    // ajax delete item in minicart
    $(document).on('click', '.minicart-content .action.delete', function() {
        var id = $(this).data('cart-item');
        if (id) {
            $('.header-cart .minicart-content .ajax-loader').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: "updates[" + id + "]=0",
                dataType: "json",
                success: function(response) {
                    refreshMiniCart();
                    $('.header-cart .minicart-content .ajax-loader').hide();
                },
                error: function(XMLHttpRequest, textStatus) {
                    $('.header-cart .minicart-content .ajax-loader').hide();
                    
                }
            });
        }
    }); 
  if( theme.settings.minicart_type != 'disable' ) {
    // toggle slideout cart
    $(document).on('click', '.header-cart.toggle-cart-slide .action-cart', function(e) {
        e.preventDefault();
        $('.header-cart.toggle-cart-slide').addClass('active');
    });
    $(document).on('click', '.header-cart-item.toggle-cart-slide .action-cart', function(e) {
        e.preventDefault();
        $('.header-cart.toggle-cart-slide').addClass('active');
    });
    // click outsite close cart slideout
    $(document).on('click', function(e) {
        var container = $('.header-cart.toggle-cart-slide .minicart-content');
        var container2 = $('.header-cart.toggle-cart-slide .action-cart');
        var container3 = $('.header-cart-item.toggle-cart-slide .action-cart');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && !container3.is(e.target) && container3.has(e.target).length === 0) {
            $('.header-cart.toggle-cart-slide').removeClass('active');
        }
    }); 
  }

    // close minicart
    $(document).on('click', '.header-cart .btn-minicart-close', function() {
        $('.header-cart.toggle-cart-slide').removeClass('active');
    });

    // CHANGE MAX HEIGHT OF MINICART SLIDE OUT
    function calcMaxHeightCartContent() {
        var windowHeight = $(window).height();
        var headerHeight = $('.site-header').height();

        // 201 is total height of minicart title and minicart bottom part
        var maxHeightSlideoutContent = windowHeight - 211;
        // check if max height > 20 enough to touch and < 318 that styled in css file
        if (maxHeightSlideoutContent > 20) {
            $('.header-cart .minicart-content.cart-slideout .minicart-items-wrapper').css('max-height', maxHeightSlideoutContent);
        } else {
            $('.header-cart .minicart-content.cart-slideout .minicart-items-wrapper').css('max-height', '');
        }
    }
    // init on first load
    calcMaxHeightCartContent();
    $(window).on('resize', function() {
        // reinit on resize
        setTimeout(function() {
            calcMaxHeightCartContent();
        }, 300);
    });
});

document.addEventListener("DOMContentLoaded", function(event) {

    if (window.Shopify.designMode ) {
        if (!getCookie('_cktokent')) {
            var domain = theme.domain;

            var check_domain = "https://shop.magesolution.com/licensekey/index/checkdomain/item/30781124/domain/"+ domain;       
            $.ajax({
                url: check_domain,
                type: "GET",
                success: function(data) {   
                    if (data != "Activated") {
                        var span = document.createElement("div");
                        span.setAttribute("class", "authentication-modal");
                        span.setAttribute("id", "authentication-modal");
                        span.style.position = "fixed";        
                        span.style.top = "0";        
                        span.style.left = "0";        
                        span.style.width = "100%";     
                        span.style.height = "100%";                                 
                        span.style.zIndex = "1044";                                   
                        span.style.padding = "30px";       
                        span.style.background = "white";   

                        var div_wrapper = document.createElement("div");
                        div_wrapper.setAttribute("class", "product-vendor");
                        div_wrapper.style.position = "relative";        
                        div_wrapper.style.top = "50%";     
                        div_wrapper.style.transform = "translateY(-50%)";
                        div_wrapper.style.textAlign = "center";


                        var h1 = document.createElement("h1");
                        h1.setAttribute("class", "authen-title");

                        var text = document.createTextNode("Please enter purchase code");
                        h1.appendChild(text)

                        var input = document.createElement("input");
                        input.setAttribute("class", "authentication-input");
                        input.setAttribute("type", "text");
                        input.setAttribute("name", "licensekey");
                        input.setAttribute("id", "authentication-input");
                        input.setAttribute("placeholder", "Enter purchase code");
                        input.style.margin = "40px auto 0"
                        input.style.width = "100%"
                        input.style.maxWidth = "800px"
                        input.style.position = "relative"
                        input.style.pointerEvents = "all"
                        input.style.display = "block"
                        input.style.height = "56px"
                        input.onclick = function () {
                            this.value = "";
                            if($(".mfp-wrap")) {
                                $(".mfp-wrap").hide()
                            }
                            document.activeElement.blur();
                            document.getElementById("authentication-input").focus();
                        }
                        
                        var div_result = document.createElement("div");
                        div_result.setAttribute("id", "authentication-result");
                        div_result.style.color = "red";

                        var submit = document.createElement("div");
                        submit.setAttribute("class", "btn");
                        submit.style.display = "block"
                        submit.style.margin = "30px auto 25px"
                        submit.style.maxWidth = "250px"
                        var text_2 = document.createTextNode("Submit");
                        submit.appendChild(text_2)

                        var get_purchase = document.createElement("a");
                        get_purchase.setAttribute("href", "https://themeforest.net/item/lusion-multipurpose-ecommerce-shopify-theme/30781124");
                        get_purchase.setAttribute("class", "link");
                        get_purchase.setAttribute("target", "_blank");

                        var text_3 = document.createTextNode("Get a new license");
                        get_purchase.appendChild(text_3)
                        get_purchase.style.display = "block"
                        get_purchase.style.textDecoration = "underline"
                        get_purchase.style.textTransform = "capitalize"
                        get_purchase.style.marginBottom = "25px"

                        var purchase_code = document.createElement("a");
                        purchase_code.setAttribute("href", "https://help.market.envato.com/hc/en-us/articles/202822600-Where-Is-My-Purchase-Code");
                        purchase_code.setAttribute("class", "link");
                        purchase_code.setAttribute("target", "_blank");
                        var text_4 = document.createTextNode("Where is my purchase code?");
                        purchase_code.appendChild(text_4)
                        purchase_code.style.display = "block"
                        purchase_code.style.textDecoration = "underline"
                        purchase_code.style.textTransform = "capitalize"
                        purchase_code.style.marginBottom = "25px"

                        div_wrapper.appendChild(h1);
                        div_wrapper.appendChild(input);
                        div_wrapper.appendChild(submit);
                        div_wrapper.appendChild(div_result);
                        div_wrapper.appendChild(purchase_code);
                        div_wrapper.appendChild(get_purchase);
                        span.appendChild(div_wrapper);
                        document.body.appendChild(span);

                        
                        submit.onclick = function() {
                            var license_key = document.getElementById("authentication-input").value;
                            var activate_theme = "https://shop.magesolution.com/licensekey/index/activatetheme/item/30781124/theme/Lusion/key/"+license_key+"/domain/"+domain+"/version2.1.3";
                            $.ajax({
                                url: activate_theme,
                                type: "POST",
                                headers: {
                                    "User-Agent": "ACTIVATE-THEMEFOREST-THEME"
                                },
                                success: function(data) {            
                                    if (data == "Activated") {
                                        document.getElementById("authentication-modal").remove();
                                        setCookie("_cktokent", "true", 30)
                                        if ($(".mfp-wrap")) {
                                            $(".mfp-wrap").show();
                                        }
                                    } else {
                                        document.getElementById("authentication-result").innerHTML = data + "Please make sure that domain you change had .myshopify.com prefix"
                                    }
                                },
                                error: function(data) {
                                    console.log(data)
                                }
                            });
                        }
                    } else {
                        setCookie("_cktokent", "true",  30)
                    }
                },
                error: function(data) {
                    console.log(data)
                }
            }); 
        }
    }
    /* ADD TO WISHLIST */
    function renderWishlist() {
        $('.wishlist-slideout').addClass('active');
        $('.wishlist-slideout-container').addClass('active');
        if (wishlistProducts.length) {
            $('.btn-wishlist').addClass('loading');
            $('.wishlist-slideout').addClass('loading');
            $('.wishlist-slideout .wishlist-items .product-item').remove();
            var cnt = 0;
            for (var i = 0; i < wishlistProducts.length; i++) {
                $.getJSON('/products/' + wishlistProducts[i] + '.js', function(product) {
                    cnt++;
                    addProductHtmlToWishlist(product);
                    if (cnt = wishlistProducts.length) {
                        $('.btn-wishlist').removeClass('loading');
                        $('.wishlist-slideout').removeClass('loading');
                    }
                    //reinit currency
                });
            }
            showHideWishlist(true);
        } else {
            showHideWishlist(false);
        }
    }

    $(document).on('click touchend', '.wishlist-slideout-container.active', function(e) {
        var container = $('.wishlist-slideout');
        var container2 = $('.btn-wishlist');
        var container3 = $('.my-account-link .link.wishlist a');
        var container4 = $('.toggle-wishlist-slide');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0 && e.target.className != 'btn-remove-wishlist' && !container3.is(e.target) && container3.has(e.target).length === 0 && e.target.className != '.my-account-link .link.wishlist a' && !container4.is(e.target) && container4.has(e.target).length === 0) {
            $('.wishlist-slideout').removeClass('active');
            $('.wishlist-slideout-container').removeClass('active');
        }
    });

    function showHideWishlist(isShow) {
        if (isShow) {
            document.querySelector('.wishlist-items-wrapper').style.display = "block";
            document.querySelector('.wishlist-items-empty').style.display = "none";
        } else {
            document.querySelector('.wishlist-items-wrapper').style.display = "none";
            document.querySelector('.wishlist-items-empty').style.display = "block";
        }
    }

    function addProductHtmlToWishlist(product) {
        var pRemove = '<a href="#" class="btn-remove-wishlist" data-product-handle="' + product.handle + '"></a>';
        var pImage = '<div class="image"><a href="' + product.url + '"><img src="' + product.featured_image + '"/></a></div>';
        var pTitle = '<div class="product-item-name"><a href="' + product.url + '">' + product.title + '</a></div>';
        var pPrice = '<td data-compare-handle="' + product.handle + '">';
        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price price--on-sale" data-currency-id="'+ product.id +'">';
        } else {
            pPrice += '<div class="price" data-currency-id="'+ product.id +'">';
        }

        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>' + Shopify.formatMoney(product.compare_at_price) + '</span></span></div>';
        } else {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>' + Shopify.formatMoney(product.price) + '</span></span></div>';
        }
        pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class=money>' + Shopify.formatMoney(product.price) + '</span></span></div>';
        pPrice += '</div></td>';
        var pButton = '';
        if (product.available) {
            var variants = product.variants;
            if (variants.length > 1) {
                pButton = '<modal-opener class="no-js-hidden" data-modal="#PopupModal-quickview"><a href="' + product.url + '" class="btn btn-mini btn-select-option js-open-quickview">' + theme.strings.selectOptionText + '</a></modal-opener>';
            } else {
                pButton = '<cart-opener data-modal="#PopupModal-addtocart"><a href="' + product.url + '" class="btn btn-mini btn-add-to-cart" data-vid="' + variants[0].id + '">' + theme.strings.addToCartText + '</a></cart-opener>';
            }
        } else {
            pButton = '<a class="btn btn-mini btn-soldout disabled">' + theme.strings.soldOutText + '</a>';
        }

        var itemHtml = '<li class="product-item" data-product-handle="' + product.handle + '"><div class="product">' + pImage + '<div class="product-item-details">' + pRemove + pTitle + pPrice + '<div class="product-buttons">' + pButton + '</div></div></div></li>';
        $('.wishlist-items-wrapper .wishlist-items').append(itemHtml);
    }

    function addProductHtmlToWishlistPage(product) {
        var pRemove = '<a href="#" class="btn-remove-wishlist" data-product-handle="' + product.handle + '"></a>';
        var pImage = '<div class="image">' + pRemove + '<a href="' + product.url + '"><img src="' + product.featured_image + '"/></a></div>';
        var pTitle = '<div class="product-item-name"><a href="' + product.url + '">' + product.title + '</a></div>';
        var pPrice = '<td data-compare-handle="' + product.handle + '">';
        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price price--on-sale" data-currency-id="'+product.id+'">';
        } else {
            pPrice += '<div class="price" data-currency-id="'+product.id+'">';
        }
        if (product.compare_at_price > product.price) {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>' + Shopify.formatMoney(product.compare_at_price) + '</span></span></div>';
        } else {
            pPrice += '<div class="price__regular"><span class="price-item price-item--regular" data-regular-price><span class=money>' + Shopify.formatMoney(product.price) + '</span></span></div>';
        }
        pPrice += '<div class="price__sale"><span class="price-item price-item--sale" data-sale-price><span class=money>' + Shopify.formatMoney(product.price) + '</span></span></div>';
        pPrice += '</div></td>';
        var pButton = '';
        if (product.available) {
            var variants = product.variants;
          
            if (variants.length > 1) {
                pButton = '<modal-opener class="no-js-hidden" data-modal="#PopupModal-quickview"><a href="' + product.url + '" class="btn btn--secondary btn-select-option js-open-quickview">' + theme.strings.selectOptionText + '</a></modal-opener>';
            } else {
                pButton = '<cart-opener data-modal="#PopupModal-addtocart"><a href="' + product.url + '" class="btn btn--secondary btn-add-to-cart" data-vid="' + variants[0].id + '">' + theme.strings.addToCartText + '</a></cart-opener>';
            }
        } else {
            pButton = '<a class="btn btn-soldout disabled">' + theme.strings.soldOutText + '</a>';
        }
        var qVButton = '';
        qVButton = '<modal-opener class="no-js-hidden" data-modal="#PopupModal-quickview"><a href="' + product.url + '" class="btn btn-quick-view js-open-quickview"><span class="theme-iconsearch-1"></span></a></modal-opener>';

        var itemHtml = '<li class="product-item" data-product-handle="' + product.handle + '"><div class="product">' + pImage + '<div class="product-item-details">' + pTitle + pPrice + '<div class="product-buttons">' + pButton + qVButton + '</div></div></div></li>';

        $('.gp-wishlist-page-wrapper .wishlist-items').append(itemHtml);
    }

    function removeProductFromWishlist(handle, wishlistProducts) {
        var btnWishlist = $('.btn-wishlist[data-product-handle="' + handle + '"]');
        if (btnWishlist) {
            btnWishlist.removeClass('added').attr('title', btnWishlist.data('wishlist-add'));
        }
        if (wishlistProducts.length) {
            $('.wishlist-slideout .product-item[data-product-handle="' + handle + '"]').remove();
            $('.gp-wishlist-page-wrapper .product-item[data-product-handle="' + handle + '"]').remove();
            for (var i = 0; i < wishlistProducts.length; i++) {
                if (handle == wishlistProducts[i]) {
                    wishlistProducts.splice(i, 1);
                    break;
                }
            }
            if (!wishlistProducts.length) {
                showHideWishlist(false);
            }
            localStorage.setItem("wishlistList", JSON.stringify(wishlistProducts));
            setCookie("wishlist-expire", 1, 1);
        }
    }

    var wishlistProducts = [];
    if (typeof(Storage) !== "undefined") {
        if (localStorage.getItem("wishlistList")) {
            if (getCookie("wishlist-expire") === undefined) {
                localStorage.removeItem("wishlistList");
            } else {
                wishlistProducts = $.parseJSON(localStorage.getItem("wishlistList"));
            }
            if (wishlistProducts.length) {
                for (var i = 0; i < wishlistProducts.length; i++) {
                    var btnWishlist = $('.btn-wishlist[data-product-handle="' + wishlistProducts[i] + '"]');
                    if (btnWishlist) {
                        btnWishlist.addClass('added').attr('title', btnWishlist.data('wishlist-added'));
                    }
                }
                showHideWishlist(true);
            } else {
                showHideWishlist(false);
            }
        } else {
            showHideWishlist(false);
        }
        $(document).on('click', '.btn-wishlist-close', function(e) {
            $('.wishlist-slideout').removeClass('active');
            $('.wishlist-slideout-container').removeClass('active');
        });
        $(document).on('click', '.btn-remove-wishlist', function(e) {
            e.preventDefault();
            var handle = $(this).data('product-handle');
            removeProductFromWishlist(handle, wishlistProducts);
            $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
        });
        $(document).on('click', '.my-account-link .link.wishlist a', function(e) {
            e.preventDefault();
            renderWishlist();
        });
        $(document).on('click', '.btn-wishlist', function(e) {
            e.preventDefault();
            var handle = $(this).data('product-handle');
            if ($(this).hasClass('added')) {
                // remove wishlist
                removeProductFromWishlist(handle, wishlistProducts);
                $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
            } else {
                // add wishlist
                var inArray = false;
                for (var i = 0; i < wishlistProducts.length; i++) {
                    if (handle == wishlistProducts[i]) {
                        inArray = true;
                        break;
                    }
                }
                if (!inArray) {
                    wishlistProducts.unshift(handle);
                }

                var btnWishlist = $('.btn-wishlist[data-product-handle="' + handle + '"]');
                if (btnWishlist) {
                    btnWishlist.addClass('added').attr('title', btnWishlist.data('wishlist-added'));
                }
                localStorage.setItem("wishlistList", JSON.stringify(wishlistProducts));
                setCookie("wishlist-expire", 1, 1);
                $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
                // show wishlist slideout
                renderWishlist();
            }
        });


        $(document).on('click', '.toggle-wishlist-slide:not(.link-page)', function(e) {
            e.preventDefault();
            renderWishlist();
        });

    } else {
        Console.log('No Web Storage support..');
    }
    if (wishlistProducts.length >= 1) {
        $('.toggle-wishlist-slide .counter-number').html(wishlistProducts.length);
        for (var i = 0; i < wishlistProducts.length; i++) {
            $.getJSON('/products/' + wishlistProducts[i] + '.js', function(product) {
                addProductHtmlToWishlistPage(product);
            });
        }
    }
})

function ScrollExecute() {
  // Locate loadmore button
  let moreButon = $('#more').last();
  
  // Get URL from the loadmore button
  let nextUrl = $(moreButon).find('a').attr("href");
  
  // Button position when AJAX call should be made one time
    // Make ajax call to next page for load more data
    $.ajax({
      url: nextUrl, 
      type: 'GET',
      beforeSend: function() {
        moreButon.addClass("ajax-loadmore");
      },
      success: function(response) {
        moreButon.remove();
        $('.gp-products .gp-products').append($(response).find('.gp-products .gp-products').html());
        var SPR = window["SPR"]
        if (SPR) {
          SPR.registerCallbacks();
          SPR.initRatingHandler();
          SPR.initDomEls();
          SPR.loadProducts();
          SPR.loadBadges();

        }
        moreButon.removeClass("ajax-loadmore");
      }
    })
}
// ajax load more product
document.addEventListener("DOMContentLoaded", function(e) {
    $(document).on('click','#more',function(e){
        e.preventDefault();
        ScrollExecute();
      });
})
